module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"detail":"詳情","buy_now":"立即購買"}}')
  delete Component.options._Ctor
}
